var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'CoreGroupbuyingsList'
      }
    }
  }, [_vm._v("團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "編輯團購" : "我要開團"))])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "編輯團購" : "我要開團") + " ")]), _c('div', {
    staticClass: "mb-3"
  }), _c('section', {
    staticClass: "mb-5"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購名稱",
      "label-for": "title"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購說明",
      "label-for": "description"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "description",
      "rows": "5",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單說明",
      "label-for": "order_message"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "order_message",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.order_message,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order_message", $$v);
      },
      expression: "form.order_message"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單完成說明",
      "label-for": "success_message"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "success_message",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.success_message,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "success_message", $$v);
      },
      expression: "form.success_message"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品",
      "label-for": "prodcut"
    }
  }, [_c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6",
    attrs: {
      "id": "prodcut",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.product_sku_id,
      callback: function callback($$v) {
        _vm.product_sku_id = $$v;
      },
      expression: "product_sku_id"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇商品編號 ")]), _vm._l(_vm.skuList, function (sku) {
    return _c('b-form-select-option', {
      key: sku.id,
      attrs: {
        "value": sku.id
      }
    }, [_vm._v(" " + _vm._s(sku.sku_name) + " ")]);
  })], 2)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "本群分配庫存",
      "label-for": "max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "max_quantity", $$v);
      },
      expression: "form.max_quantity"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "成團數",
      "label-for": "quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.quantity.$error ? false : null,
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "quantity", $$v);
      },
      expression: "form.quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.quantity.less.$invalid
    }
  }, [_vm._v(" 需小於商品總數上限 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "成團後是否可繼續登記",
      "label-for": "is_force_confirmed"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "is_force_confirmed",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.is_force_confirmed,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_force_confirmed", $$v);
      },
      expression: "form.is_force_confirmed"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared,
      "state": _vm.v$.form.once_max_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於商品總數上限 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared,
      "state": _vm.v$.form.once_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於每人最高購買數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared,
      "state": _vm.v$.form.once_increase_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "開始時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": !_vm.isEdit && !_vm.isStatusPrepared,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "date", $$v);
      },
      expression: "form.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error
      }],
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "time", $$v);
      },
      expression: "form.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.time.HH.$error || !_vm.v$.form.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "截止時間",
      "description": "*達截止時間系統將自動結團"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": !_vm.isEdit,
      "input-class": {
        'is-invalid': _vm.v$.form.start_at.$invalid
      },
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "date", $$v);
      },
      expression: "form.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 截止時間必須大於開團時間 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "disabled": !_vm.isEdit,
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error || _vm.v$.form.start_at.date.beforeEndAt.$invalid
      }]
    },
    model: {
      value: _vm.form.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "time", $$v);
      },
      expression: "form.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.time.HH.$error || !_vm.v$.form.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序",
      "label-for": "order"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "id": "order",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "追蹤碼",
      "label-for": "tracking_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "id": "tracking_code",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.tracking_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tracking_code", $$v);
      },
      expression: "form.tracking_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "付款期限",
      "label-for": "input-1"
    }
  }, [_c('div', [_vm._v(" 結單後 "), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "disabled": !_vm.isEdit,
      "state": _vm.v$.form.payday_period && _vm.v$.form.payday_period.$error ? false : null,
      "formatter": function formatter(val) {
        return val < 1 ? 1 : val;
      }
    },
    model: {
      value: _vm.form.payday_period,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "payday_period", $$v);
      },
      expression: "form.payday_period"
    }
  }), _vm._v(" 日後停止付款 ")], 1), _c('div', [_vm._v("預計付款截止日：" + _vm._s(_vm.estimatedEndDate) + " 23:59")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "可否重複下單",
      "label-for": "can_order_again"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "can_order_again",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.can_order_again,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "can_order_again", $$v);
      },
      expression: "form.can_order_again"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否需要選擇數量",
      "label-for": "need_choose_number"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "need_choose_number",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.need_choose_number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "need_choose_number", $$v);
      },
      expression: "form.need_choose_number"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否要選擇分店",
      "label-for": "need_choose_branch"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "need_choose_branch",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.need_choose_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "need_choose_branch", $$v);
      },
      expression: "form.need_choose_branch"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否顯示商品價格",
      "label-for": "show_price"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "id": "show_price",
      "disabled": !_vm.isEdit
    },
    model: {
      value: _vm.form.show_price,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "show_price", $$v);
      },
      expression: "form.show_price"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancelGroupbuy
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "取消編輯" : "取消開團"))]), _vm.isEdit ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmitGroupbuy
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? "確認編輯" : "確認開團"))]) : _vm._e()], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }